import { render, staticRenderFns } from "./chongzhiDialog.vue?vue&type=template&id=59dc7bf8&scoped=true"
import script from "./chongzhiDialog.vue?vue&type=script&lang=js"
export * from "./chongzhiDialog.vue?vue&type=script&lang=js"
import style0 from "./chongzhiDialog.vue?vue&type=style&index=0&id=59dc7bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc7bf8",
  null
  
)

export default component.exports